import { createSwrListStore } from './swr/createSwrListStore';
import { listVideoLibrary } from '../lib/api';

const swr = createSwrListStore({
  name: 'VideoLibraryStore',
  storageKey: 'bookthing-video-library',
  itemsField: 'libraryVideos',
  maxItems: 60,
  setters: {
    set: 'setLibraryVideos',
    add: 'addLibraryVideo',
    update: 'updateLibraryVideo',
    remove: 'removeLibraryVideo',
    reset: 'resetLibraryVideos',
  },
  fetcher: async () => {
    const response = await listVideoLibrary({ page: 1, limit: 30, search: null });
    return response.videos || [];
  },
});

export const useVideoLibraryStore = swr.useStore;
export const useVideoLibraryData = swr.useData;
export const fetchVideoLibraryIfStale = swr.fetchIfStale;

